import apiClient from '../services/api/client';

// ============================================
// TYPES
// ============================================

export interface DashboardStats {
  totalProducts: number;
  activeProducts: number;
  productsWithErrors: number;
  pendingMappings: number;
  totalOrders: number;
  ordersToday: number;
  revenue: number;
  revenueChange: number;
  channelDistribution: Array<{
    marketplaceId: string;
    marketplaceName: string;
    productCount: number;
    percentage: number;
    color: string;
  }>;
  recentErrors: Array<{
    id: string;
    code: string;
    message: string;
    severity: string;
    timestamp: string;
  }>;
  syncStatus: {
    price: boolean;
    discountPrice: boolean;
    stock: boolean;
    productData: boolean;
    lastSync: string;
  };
}

// ============================================
// SERVICE
// ============================================

export const DashboardService = {
  /**
   * Busca estatísticas do dashboard
   * GET /site/site/api/hub/dashboard/stats
   */
  async getStats(): Promise<DashboardStats> {
    try {
      const response = await apiClient.get<DashboardStats>('/dashboard/stats');

      return response.data;
    } catch (error: any) {
      console.error('Erro ao buscar estatísticas do dashboard:', error);
      throw new Error(error.message || 'Erro ao buscar estatísticas');
    }
  },

  /**
   * Força sincronização de todos os produtos
   * POST /site/site/api/hub/sync/all
   */
  async syncAll(): Promise<{ message: string; status: string }> {
    try {
      const response = await apiClient.post('/sync/all');
      return response.data;
    } catch (error: any) {
      console.error('Erro ao iniciar sincronização:', error);
      throw new Error(error.message || 'Erro ao iniciar sincronização');
    }
  },
};

export default DashboardService;
